<template>
  <div class="comp-main-image" @mouseenter="setPasteY" @mouseleave="setPasteN">
    <el-upload
      ref="refUpload"
      :limit="limit"
      action="#"
      list-type="picture-card"
      :accept="selfType"
      :multiple="limit > 1"
      :file-list="selfList.slice(0, limit)"
      :http-request="fileUpload"
      :on-remove="fileDelete"
      :on-exceed="fileExceed"
      :before-upload="beforeAvatarUpload"
      drag
    >
      <div
        v-if="!selfDisabled"
        slot="default"
        class="img-add-box"
        :title="$constant.uploadImagePrompt(limit, fileSize, fileType, filePrompt)"
      >
        <p class="el-icon-plus"></p>
        <slot></slot>
      </div>
      <template #file="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" />
        <div class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" title="放大">
            <i class="el-icon-zoom-in">
              <el-image
                :src="file.url"
                :preview-src-list="imgUrlList"
                @click.stop.prevent="bigImageAddElement"
              />
            </i>
          </span>
          <span
            v-if="selfDelete && Number(size.split('px')[0]) >= 40"
            class="el-upload-list__item-delete"
            title="删除"
            @click="fileDelete(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </div>
      </template>
    </el-upload>
    <div v-if="selfDisabled && !selfList.length" class="iconfont icon-default-image"></div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    fileType: {
      type: Array,
      default: () => {
        return ['jpg', 'jpeg', 'png']
      }
    },
    fileSize: {
      type: Number,
      default: 10 // MB
    },
    filePrompt: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '26px'
    },
    limit: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    isReadImg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfList: [],
      isPaste: false
    }
  },
  computed: {
    selfType() {
      let result = this.$util.deepCopy(this.fileType)
      result = result.map((item) => `.${item}`).join(',')
      return result
    },
    selfDisabled() {
      return this.selfList.length >= this.limit || this.disabled
    },
    selfDelete() {
      return this.isDelete && !this.disabled
    },
    uploadDisplay() {
      return this.selfDisabled ? 'none' : 'inline-block'
    },
    lastImgMarginSize() {
      return this.selfDisabled ? '0' : '5px'
    },
    iconSize() {
      let result = '20px'
      let sizeArr = this.size.split('px')
      if (sizeArr.length) {
        let size = Number(sizeArr[0])
        if (size > 80 && size <= 100) {
          result = '18px'
        }
        if (size > 60 && size <= 80) {
          result = '16px'
        }
        if (size > 40 && size <= 60) {
          result = '14px'
        }
        if (size <= 40) {
          result = '12px'
        }
      }
      return result
    },
    iconMarginLeft() {
      let result = '10px'
      let sizeArr = this.size.split('px')
      if (sizeArr.length) {
        let size = Number(sizeArr[0])
        if (size > 80 && size <= 100) {
          result = '10px'
        }
        if (size > 60 && size <= 80) {
          result = '8px'
        }
        if (size > 40 && size <= 60) {
          result = '6px'
        }
        if (size <= 40) {
          result = '4px'
        }
      }
      return result
    },
    imgUrlList() {
      return this.selfList.map((item) => item.url)
    }
  },
  watch: {
    list: {
      handler(val) {
        if (JSON.stringify(this.selfList) !== JSON.stringify(val)) {
          this.selfList = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    },
    selfList: {
      handler(val) {
        if (JSON.stringify(this.list) !== JSON.stringify(val)) {
          this.$emit('update:list', val)
        }
      },
      deep: true
    }
  },
  mounted() {
    // 监听全局粘贴事件
    document.addEventListener('paste', this.filePaste)
  },
  beforeDestroy() {
    // 销毁时移除监听
    document.removeEventListener('paste', this.filePaste)
  },
  methods: {
    setPasteY() {
      this.isPaste = true
    },
    setPasteN() {
      this.isPaste = false
    },
    // 处理粘贴事件
    filePaste(event) {
      if (!this.isPaste) return
      if (this.selfDisabled) return
      let items = event.clipboardData?.items
      if (!items) return
      // 遍历剪贴板中的内容，找到图片
      let imgArr = []
      for (let item of items) {
        if (item.type.includes('image')) {
          imgArr.push(item)
        }
      }
      // 可拷贝最大数
      let pasteMax = this.limit - this.selfList.length
      if (pasteMax > 0) {
        imgArr.forEach((item, index) => {
          if (index < pasteMax) {
            let blob = item.getAsFile()
            if (blob) {
              let file = new File([blob], 'screenshot.png', { type: blob.type }) // 将 Blob 转换为 File 对象
              this.fileUpload({ file }) // 手动触发 el-upload 上传
            }
          }
        })
      }
    },
    // 文件上传
    fileUpload(option) {
      let data = new FormData()
      let file = option.file
      data.append('file', file)
      data.append('uid', file.uid)
      if (this.isReadImg) data.append('type', 'ocr')
      this.$api({
        method: 'post',
        url: '/admin/upload/imgCommon',
        data
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            if (this.isReadImg) {
              this.selfList = []
              this.$emit('success', res.data.ocr)
              this.$message.success('图片识别成功!')
            } else {
              this.selfList.push(res.data.img)
              this.$message.success('图片上传成功!')
            }
          } else {
            this.fileDelete(file) // 上传失败，直接移除
          }
        })
        .catch(() => {
          this.fileDelete(file) // 上传失败，直接移除
        })
    },
    // 文件删除
    fileDelete(file) {
      let index = this.selfList.findIndex((item) => item.id === file.id)
      this.selfList.splice(index, 1)
      this.$api({
        method: 'post',
        url: '/admin/upload/deleteImg',
        data: {
          url: file.url,
          uid: file.uid
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          // this.$message.success('图片删除成功！')
        } else {
          this.$message.error('图片删除失败！')
        }
      })
    },
    // 文件超出限制
    fileExceed() {
      this.$message.error(`最多上传${this.limit}张图片！`)
    },
    // 上传前限制
    beforeAvatarUpload(file) {
      let listType = this.fileType.map((str) => str.toLowerCase())
      const isPassType = listType.some((item) => file.type.includes(item))
      const isPassFileSize = file.size / 1024 / 1024 < this.fileSize
      if (!isPassType) this.$message.error(`文件只能是${listType.join(',')}格式!`)
      if (!isPassFileSize) this.$message.error(`文件大小不能超过${this.fileSize}MB!`)

      return isPassType && isPassFileSize
    },
    // 文件下载
    fileDownload(file) {
      window.open(file.url, '_blank')
    },
    // 放大图片组件-新增下载、删除元素
    bigImageAddElement() {
      this.$nextTick(() => {
        let wrapper = document.getElementsByClassName('el-image-viewer__actions__inner')

        // 新增图片下载按钮
        let downloadBtn = document.createElement('i')
        downloadBtn.setAttribute('class', 'el-icon-download')
        downloadBtn.addEventListener('click', this.bigImageDownload)
        wrapper[0].appendChild(downloadBtn)

        // 新增图片删除按钮
        if (this.selfDelete) {
          let deleteBtn = document.createElement('i')
          deleteBtn.setAttribute('class', 'el-icon-delete')
          deleteBtn.addEventListener('click', this.bigImageDelete)
          wrapper[0].appendChild(deleteBtn)
        }

        if (wrapper.length > 0) {
          this.wrapperElem = wrapper[0]
        }
      })
    },
    // 放大图片组件-图片下载
    bigImageDownload() {
      let imgUrl = document.getElementsByClassName('el-image-viewer__img')[0].src
      this.fileDownload({ url: imgUrl })
    },
    // 放大图片组件-图片删除
    bigImageDelete() {
      let imgUrl = document.getElementsByClassName('el-image-viewer__img')[0].src
      let index = this.selfList.findIndex((item) => item.url === imgUrl)
      this.selfList.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main-image {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: v-bind(size);
  height: v-bind(size);
  background: @colorWhite;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  .img-add-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    line-height: 1;
  }
  .icon-default-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: v-bind(size);
    height: v-bind(size);
    font-size: 26px;
    color: @colorGrayE;
    background: @colorWhite;
  }
  /deep/ .el-upload,
  /deep/ .el-upload-list__item {
    width: v-bind(size);
    height: v-bind(size);
    line-height: 1;
    transition: none; // 去除默认fade动画
    margin-bottom: 0;
  }

  /deep/ .el-upload-list--picture-card {
    line-height: 0;
    .el-upload-list__item-actions {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: v-bind(iconSize);
      span + span {
        margin-left: v-bind(iconMarginLeft);
      }
    }
  }

  /deep/ .el-icon-zoom-in {
    position: relative;
    .el-image {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
  }

  // 上传列表
  /deep/ .el-upload-list__item {
    margin-right: 5px;
    border-radius: 4px;
    border: none;
    &:last-child {
      margin-right: v-bind(lastImgMarginSize);
    }
    &.is-ready {
      display: none;
    }
    .el-upload-list__item-status-label {
      display: none;
    }
  }

  // 上传控件
  /deep/ .el-upload {
    display: v-bind(uploadDisplay); // 达到限制，不显示上传
    height: v-bind(size);
    line-height: v-bind(size);
    overflow: hidden;

    .el-upload-dragger {
      background-color: transparent;
      border: none;
      border-radius: 4px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      text-align: center;
      cursor: pointer;
      overflow: hidden;
    }

    &.el-upload--picture-card {
      background: @colorGrayF;
      border-radius: 4px;
      border: none;
      &:hover,
      &:focus {
        background: #ecf5ff;
        p {
          color: @colorBlue;
        }
      }
      p {
        margin: 0;
        font-size: v-bind(iconSize);
        color: @colorGray;
        & ~ p {
          padding-top: 5px;
        }
      }
    }
  }
}
</style>
